module.exports = {
    "isLoop": true,
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/bomb/bomb01.png").default
        },
        {
            "time": 500,
            "image": require("@frog/source/assets/images/bomber-tactics/bomb/bomb02.png").default
        },
        {
            "time": 600,
            "image": require("@frog/source/assets/images/bomber-tactics/bomb/bomb03.png").default
        },
        {
            "time": 700,
            "image": require("@frog/source/assets/images/bomber-tactics/bomb/bomb04.png").default
        },
        {
            "time": 800,
            "image": require("@frog/source/assets/images/bomber-tactics/bomb/bomb03.png").default
        },
        {
            "time": 900,
            "image": require("@frog/source/assets/images/bomber-tactics/bomb/bomb02.png").default
        },
        {
            "time": 1000,
            "image": require("@frog/source/assets/images/bomber-tactics/bomb/bomb01.png").default
        },
    ]
}
